module.exports = __webpack_public_path__ + "static/media/BlockWater.11e4cd92.jpg";